import { companyApi, companyQueryKeys } from "service/crm/api/company";
import { useActivityFeed } from "../useActivityFeed";

export const useCompanyActivity = (companyUuid: string, pageSize = 20) =>
  useActivityFeed(
    companyQueryKeys.activities(companyUuid),
    (page) =>
      companyApi.getCompanyActivities(companyUuid, page, pageSize, "ALL_ACTIVITIES"),
    !!companyUuid,
  );